'use client'

import { Card, Pagination } from '@vinted/web-ui'
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'

import { MEMBER_FOLLOWERS_URL } from 'constants/routes'
import { scrollToTop } from '@marketplace-web/shared/browser'

type Props = {
  page: number
  userId: number
  totalPages: number
}

const PaginationComponent = ({ userId, page, totalPages }: Props) => {
  const router = useRouter()
  const [isLoading, startTransition] = useTransition()

  if (totalPages <= 1) return null

  const setNewPage = (newPage: number, event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault()
    startTransition(() => {
      router.push(MEMBER_FOLLOWERS_URL(userId, newPage))
    })
    scrollToTop('smooth')
  }

  return (
    <div data-loading={isLoading}>
      <Card>
        <Pagination
          currentPage={page}
          pageCount={totalPages}
          urlBuilder={currentPage => MEMBER_FOLLOWERS_URL(userId, currentPage)}
          onNextClick={setNewPage}
          onPrevClick={setNewPage}
          onPageClick={setNewPage}
          testId="user-followers-pagination"
        />
      </Card>
    </div>
  )
}

export default PaginationComponent
